import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";
import OpenApp from "react-open-app";

import Chrome from "../assets/images/Chrome.png";

const ChromeModal = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  const isChromeAlert = () => {
    const isStay = localStorage.getItem("isChromeAlert");

    return isStay && isStay === "true";
  };
  useEffect(() => {
    const isChrome = navigator.userAgent.indexOf("Chrome") >= 0;
    console.log("isChrome", isChrome);
    setVisible(!isChrome && !isChromeAlert());
  }, [pathname]);
  return (
    <CModal visible={visible} closable={false} footer={null}>
      <ChromeImg src={Chrome} />
      <TextContainer>
        <Header>เพื่อการใช้งานได้ดียิ่งขึ้น</Header>
        <Description>แนะนำให้คุณใช้งานผ่าน Google Chrome</Description>
      </TextContainer>
      <center>
        <ButtonGroup>
          <ConfirmBtn
            href="https://www.google.com/chrome/"
            android="https://play.google.com/store/apps/details?id=com.android.chrome"
            ios="https://apps.apple.com/th/app/google-chrome/id535886823"
            target="_blank"
            onClick={() => {
              localStorage.setItem("isChromeAlert", "true");
              setVisible(false);
            }}
          >
            เปิดบน Google Chrome
          </ConfirmBtn>
          <Staylabel
            onClick={() => {
              localStorage.setItem("isChromeAlert", "true");
              setVisible(false);
            }}
          >
            ใช้งานต่อ
          </Staylabel>
        </ButtonGroup>
      </center>
    </CModal>
  );
};

export default ChromeModal;

const CModal = styled(Modal)`
  font-family: "Noto Sans Thai", "Noto Sans";

  width: 320px !important;

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 36px;
  }

  .ant-modal-content {
    border-radius: 8px;
  }
`;

const ChromeImg = styled.img`
  margin-bottom: 26px;
  margin-top: 10px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height, or 140% */

  text-align: center;

  /* Primary/Green 500 */

  color: #058459;
`;

const Description = styled.span`
  width: 162px;
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: #4b5768;
  margin-top: 4px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 16px;
`;

const ConfirmBtn = styled(OpenApp)`
  border-radius: 100px;
  width: 232px;
  height: 51px;
  color: #ffffff;
  background: #16af7b;
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;

  &:disabled {
    background: #d0d5dd;
    color: #64748b;
  }

  :hover,
  :focus {
    color: #16af7b;
    border: 1px solid #16af7b;
    background: #ffffff;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s all ease;
`;

const Staylabel = styled.label`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-decoration-line: underline;

  color: #058459;

  margin-top: 16px;

  :hover {
    cursor: pointer;
  }
`;
